import { host } from "../../config/Config";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./style/style-mob.css";
import img from "../../resources/logo.webp";

export const Login = () => {
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    // Function to check if user is already authenticated
    const checkUser = async () => {
        // Check for education user token first
        const userType = localStorage.getItem("zajednica-user-type");
        const zajednicaToken = localStorage.getItem("zajednica-token");

        if (zajednicaToken && userType === "education") {
            navigate("/profile");
            return;
        }

        // Check for admin token
        const token = localStorage.getItem("jwt-vlada");
        if (!token) return; // No token, so no need to check

        try {
            const response = await fetch(`${host}/api/v1/auth/check-user`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const isAuthenticated = await response.json();
            if (response.ok && isAuthenticated) {
                navigate("/admin"); // Redirect if authenticated
            }
        } catch (error) {
            navigate("/");
        }
    };

    useEffect(() => {
        checkUser();
    }, []);

    const handleLogin = async () => {
        if (password.trim() === "") {
            setError("Unesi lozinku");
            return;
        }

        try {
            const response = await fetch(`${host}/api/v1/auth/login-admin`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ password }),
            });

            const token = await response.text();
            if (response.ok && token) {
                localStorage.setItem("jwt-vlada", token);
                setError("");
                navigate("/admin"); // Redirect to admin page after login
            } else {
                setPassword("");
                setError("Netačna lozinka");
            }
        } catch (error) {
            setPassword("");
            setError("Došlo je do greške.");
        }
    };

    return (
        <div className='barber-zajednica-admin-page'>
            <div className='barber-zajednica-admin-background'></div>
            <h1>Prijava</h1>
            <input
                type='password'
                placeholder={error ? error : "Unesi lozinku"}
                className={
                    error
                        ? "barber-zajednica-input-password-invalid"
                        : "barber-zajednica-input-password"
                }
                value={password}
                onChange={(e) => setPassword(e.target.value)}
            />
            <button
                className='barber-zajednica-login-button'
                onClick={handleLogin}
            >
                Prijavi se
            </button>
            <div className='barber-zajednica-admin-logo'>
                <img src={img} alt='Logo' />
            </div>
        </div>
    );
};
